import DragHandler from '@/utils/dragHandler';
const findParent = (el, index = 1) => {
    return index > 0 && el?.parentNode ? findParent(el.parentNode, index - 1) : el;
};
let dh;
export default {
    mounted(el, binding) {
        if (binding.value?.disable) {
            return;
        }
        el.style.cursor = 'move';
        let element = el;
        if (binding.value?.target) {
            element = findParent(el, binding.value?.target);
        }
        dh = new DragHandler(el, element, binding.value?.callback, binding.value?.transform);
    },
    beforeUnmount(el) {
        if (dh) {
            dh.off();
        }
    }
};
